module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ballsaal"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.headline)
    }
  }), _c('seperator'), _c('div', {
    staticClass: "body"
  }, [_vm._l((_vm.body), function(paragraph) {
    return _c('p', {
      domProps: {
        "innerHTML": _vm._s(paragraph)
      }
    })
  }), _c('a', {
    staticClass: "cta",
    attrs: {
      "href": "mailto:" + _vm.email
    }
  }, [_vm._v("Jetzt Anfragen")])], 2), _c('div', {
    staticClass: "clear"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-586419d6"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Ballsaal.vue
// module id = 427
// module chunks = 1